import classnames from 'classnames';
import { FC, ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react';

type TypographyProps = {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'intro' | 'body' | 'small';
  color?: 'gray' | 'white' | 'light-gray' | 'green';
  children: ReactNode;
  className?: string;
  slot?: string;
};

type Element = HTMLHeadingElement & HTMLSpanElement & HTMLParagraphElement;

const variantsMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  intro: 'p',
  small: 'span',
  body: 'p'
};

type ComponentProps = {
  tagName?: string;
  children: ReactNode;
  ref?: ForwardedRef<Element>;
} & HTMLAttributes<Element>;

const Component: FC<ComponentProps> = ({
  tagName: Wrapper = 'p',
  children,
  ...rest
}) => <Wrapper {...rest}>{children}</Wrapper>;

export const Typography: FC<TypographyProps> = forwardRef<
  Element,
  TypographyProps
>(({ color, className, children, variant = 'body', ...rest }, ref) => (
  <Component
    {...rest}
    tagName={variantsMapping[variant]}
    className={classnames(className, {
      'text-small': variant === 'small',
      'text-intro': variant === 'intro',
      [`text-${color}`]: color
    })}
    ref={ref}>
    {children}
  </Component>
));
